import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-zimbabwe-motor-insurance.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var CalculatorZimbabweMotorInsurance = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorZimbabweMotorInsurance, _super);
    function CalculatorZimbabweMotorInsurance(element) {
        return _super.call(this, element) || this;
    }
    CalculatorZimbabweMotorInsurance.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInsuranceTerm = this.element.querySelector('.js-insurance-term');
        this.totalRoadLevy = this.element.querySelector('.js-road-levy');
        this.totalStampDuty = this.element.querySelector('.js-stamp-duty');
        this.inputCurrency = this.element.querySelector('select[name=js-input-currency]');
        this.inputStartDate = this.element.querySelector('input[name=js-input-startdate]');
        this.inputEndDate = this.element.querySelector('input[name=js-input-enddate]');
        this.inputAmountInsured = this.element.querySelector('input[name=js-input-amount-insured]');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-zimbabwe-motor-insurance__result--terms');
        this.containerSchedule = document.querySelector('.js-amort-schedule-business-loan-calculator');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        $(document).ready(function () {
            //////////////////////////
            // start dateppicker
            //////////////////////////
            $('input.js-input-startdate').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            });
            var dateCurrent = new Date();
            var dateCurrentYear = dateCurrent.getFullYear();
            var dateCurrentMonth = (dateCurrent.getMonth() + 1).toString().padStart(2, "0");
            var dateCurrentDate = dateCurrent.getDate().toString().padStart(2, "0");
            var dateCurrentFormatted = dateCurrentDate + '/' + dateCurrentMonth + '/' + dateCurrentYear;
            $('input.js-input-startdate').datepicker('setDate', dateCurrentFormatted);
            $('input.js-input-startdate').datepicker('setStartDate', dateCurrentFormatted);
            $('input.js-input-startdate').on('changeDate', function (e) {
                var dateFuture = e.date;
                dateFuture.setMonth(dateCurrent.getMonth() + 4);
                var dateFutureYear = dateFuture.getFullYear();
                var dateFutureMonth = (dateFuture.getMonth() + 1).toString().padStart(2, "0");
                var dateFutureDate = dateFuture.getDate().toString().padStart(2, "0");
                var dateFutureFormatted = dateFutureDate + '/' + dateFutureMonth + '/' + dateFutureYear;
                $('input.js-input-enddate').datepicker('setDate', dateFutureFormatted);
                $('input.js-input-enddate').datepicker('setStartDate', dateFutureFormatted);
                varStartDate = e.date;
                var dateFutureEnd = e.date;
                dateFutureEnd.setMonth(dateCurrent.getMonth() + 12);
                var dateFutureEndYear = dateFutureEnd.getFullYear();
                var dateFutureEndMonth = (dateFutureEnd.getMonth() + 1).toString().padStart(2, "0");
                var dateFutureEndDate = dateFutureEnd.getDate().toString().padStart(2, "0");
                var dateFutureEndFormatted = dateFutureEndDate + '/' + dateFutureEndMonth + '/' + dateFutureEndYear;
                $('input.js-input-enddate').datepicker('setEndDate', dateFutureEndFormatted);
                varEndDate = dateFutureEnd;
            });
            //////////////////////////
            // end dateppicker
            //////////////////////////
            $('input.js-input-enddate').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            });
            var dateFuture = new Date();
            dateFuture.setMonth(dateCurrent.getMonth() + 4);
            var dateFutureYear = dateFuture.getFullYear();
            var dateFutureMonth = (dateFuture.getMonth() + 1).toString().padStart(2, "0");
            var dateFutureDate = dateFuture.getDate().toString().padStart(2, "0");
            var dateFutureFormatted = dateFutureDate + '/' + dateFutureMonth + '/' + dateFutureYear;
            $('input.js-input-enddate').datepicker('setDate', dateFutureFormatted);
            $('input.js-input-enddate').datepicker('setStartDate', dateFutureFormatted);
            var dateFutureEnd = new Date();
            dateFutureEnd.setMonth(dateCurrent.getMonth() + 12);
            var dateFutureEndYear = dateFutureEnd.getFullYear();
            var dateFutureEndMonth = (dateFutureEnd.getMonth() + 1).toString().padStart(2, "0");
            var dateFutureEndDate = dateFutureEnd.getDate().toString().padStart(2, "0");
            var dateFutureEndFormatted = dateFutureEndDate + '/' + dateFutureEndMonth + '/' + dateFutureEndYear;
            $('input.js-input-enddate').datepicker('setEndDate', dateFutureEndFormatted);
        });
        var dateCurrent = new Date();
        var varStartDate = dateCurrent;
        var dateFuture = new Date();
        dateFuture.setMonth(dateFuture.getMonth() + 4);
        var varEndDate = dateFuture;
        this.calculate(varStartDate, varEndDate);
        TooltipsService.initTooltips();
    };
    CalculatorZimbabweMotorInsurance.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            var inputCurrencies = Array.from(_this.element.querySelectorAll('.calculator-form__title--currency'));
            var totalCurrencies = Array.from(_this.element.querySelectorAll('.calculator-item__title--currency'));
            var contentCurrencies = Array.from(_this.element.querySelectorAll('.calculator-zimbabwe-motor-insurance__result--summary__value--currency'));
            inputCurrencies.map(function (item) {
                item.innerHTML = 'Z$';
            });
            totalCurrencies.map(function (item) {
                item.innerHTML = 'Z$';
            });
            contentCurrencies.map(function (item) {
                item.innerHTML = 'Z$';
            });
            var dateCurrent = new Date();
            var dateCurrentYear = dateCurrent.getFullYear();
            var dateCurrentMonth = (dateCurrent.getMonth() + 1).toString().padStart(2, "0");
            var dateCurrentDate = dateCurrent.getDate().toString().padStart(2, "0");
            var dateCurrentFormatted = dateCurrentDate + '/' + dateCurrentMonth + '/' + dateCurrentYear;
            $('input.js-input-startdate').datepicker('setDate', dateCurrentFormatted);
            $('input.js-input-startdate').datepicker('setStartDate', dateCurrentFormatted);
            var dateFuture = new Date();
            dateFuture.setMonth(dateCurrent.getMonth() + 4);
            var dateFutureYear = dateFuture.getFullYear();
            var dateFutureMonth = (dateFuture.getMonth() + 1).toString().padStart(2, "0");
            var dateFutureDate = dateFuture.getDate().toString().padStart(2, "0");
            var dateFutureFormatted = dateFutureDate + '/' + dateFutureMonth + '/' + dateFutureYear;
            $('input.js-input-enddate').datepicker('setDate', dateFutureFormatted);
            $('input.js-input-enddate').datepicker('setStartDate', dateFutureFormatted);
            var dateFutureEnd = new Date();
            dateFutureEnd.setMonth(dateCurrent.getMonth() + 12);
            var dateFutureEndYear = dateFutureEnd.getFullYear();
            var dateFutureEndMonth = (dateFutureEnd.getMonth() + 1).toString().padStart(2, "0");
            var dateFutureEndDate = dateFutureEnd.getDate().toString().padStart(2, "0");
            var dateFutureEndFormatted = dateFutureEndDate + '/' + dateFutureEndMonth + '/' + dateFutureEndYear;
            $('input.js-input-enddate').datepicker('setEndDate', dateFutureEndFormatted);
            _this.calculate();
        });
        if (this.inputCurrency) {
            this.inputCurrency.addEventListener('change', function (evt) {
                var inputCurrencies = Array.from(_this.element.querySelectorAll('.calculator-form__title--currency'));
                var totalCurrencies = Array.from(_this.element.querySelectorAll('.calculator-item__title--currency'));
                var contentCurrencies = Array.from(_this.element.querySelectorAll('.calculator-zimbabwe-motor-insurance__result--summary__value--currency'));
                if (evt.target.value === 'ZWL') {
                    inputCurrencies.map(function (item) {
                        item.innerHTML = 'Z$';
                    });
                    totalCurrencies.map(function (item) {
                        item.innerHTML = 'Z$';
                    });
                    contentCurrencies.map(function (item) {
                        item.innerHTML = 'Z$';
                    });
                    _this.inputAmountInsured.value = 22500;
                    _this.inputAmountInsured.setAttribute('value', 22500);
                    _this.inputAmountInsured.setAttribute('data-value', 22500);
                    _this.inputAmountInsured.setAttribute('min', 22500);
                    _this.inputAmountInsured.setAttribute('placeholder', 22500);
                    _this.calculate();
                }
                else {
                    inputCurrencies.map(function (item) {
                        item.innerHTML = '$';
                    });
                    totalCurrencies.map(function (item) {
                        item.innerHTML = '$';
                    });
                    contentCurrencies.map(function (item) {
                        item.innerHTML = '$';
                    });
                    _this.inputAmountInsured.value = 100;
                    _this.inputAmountInsured.setAttribute('value', 100);
                    _this.inputAmountInsured.setAttribute('data-value', 100);
                    _this.inputAmountInsured.setAttribute('min', 100);
                    _this.inputAmountInsured.setAttribute('placeholder', 100);
                    _this.calculate();
                }
            });
        }
    };
    CalculatorZimbabweMotorInsurance.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    CalculatorZimbabweMotorInsurance.prototype.scrollHorizontally = function (event) {
        event = window.event || event;
        var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        event.currentTarget.scrollLeft -= (delta * 40); // Multiplied by 40
        event.preventDefault();
    };
    CalculatorZimbabweMotorInsurance.prototype.calculate = function (dateFrom, dateTo) {
        if (dateFrom === void 0) { dateFrom = ''; }
        if (dateTo === void 0) { dateTo = ''; }
        var dateStart = $(document).find('input.js-input-startdate');
        var dateStartValue = dateStart.val();
        var dateStartArray = dateStartValue.split('/', 3);
        var dateEnd = $(document).find('input.js-input-enddate');
        var dateEndValue = dateEnd.val();
        var dateEndArray = dateEndValue.split('/', 3);
        var dateFinalStart = dateFrom;
        var dateFinalEnd = dateTo;
        if (dateStartArray[0] && dateEndArray[0]) {
            var dateSetStart = new Date();
            dateSetStart.setDate(parseFloat(dateStartArray[0]));
            dateSetStart.setMonth(parseFloat(dateStartArray[1]) - 1);
            dateSetStart.setYear(parseFloat(dateStartArray[2]));
            dateFinalStart = dateSetStart;
            var dateSetEnd = new Date();
            dateSetEnd.setDate(parseFloat(dateEndArray[0]));
            dateSetEnd.setMonth(parseFloat(dateEndArray[1]) - 1);
            dateSetEnd.setYear(parseFloat(dateEndArray[2]));
            dateFinalEnd = dateSetEnd;
        }
        var dateDifferenceDAys = this.differenceBetweenDays(dateFinalStart, dateFinalEnd) + 1;
        var dateDifferenceMonths = this.differenceBetweenMonths(dateFinalStart, dateFinalEnd);
        this.totalInsuranceTerm.innerHTML = dateDifferenceMonths + ' months';
        this.varMonthDifference = dateDifferenceMonths;
        var total = 0;
        var roadLevy = 3.60;
        var stampDuty = 0;
        var premiumInsuredAmount = 0;
        if (this.inputAmountInsured.value) {
            premiumInsuredAmount = this.inputAmountInsured.value * 0.045;
            total = total + premiumInsuredAmount;
            total = total * (dateDifferenceDAys / 365);
        }
        stampDuty = this.round(total, 2) * 0.05;
        this.totalRoadLevy.innerHTML = roadLevy;
        this.totalStampDuty.innerHTML = this.round(stampDuty, 2);
        this.totalMonthly.innerHTML = this.round((total + stampDuty + roadLevy), 2);
    };
    CalculatorZimbabweMotorInsurance.prototype.differenceBetweenMonths = function (dateFrom, dateTo) {
        if (dateFrom === void 0) { dateFrom = ''; }
        if (dateTo === void 0) { dateTo = ''; }
        return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()));
    };
    CalculatorZimbabweMotorInsurance.prototype.differenceBetweenDays = function (dateFrom, dateTo) {
        if (dateFrom === void 0) { dateFrom = ''; }
        if (dateTo === void 0) { dateTo = ''; }
        var Difference_In_Time = dateTo.getTime() - dateFrom.getTime();
        return Difference_In_Time / (1000 * 3600 * 24);
    };
    CalculatorZimbabweMotorInsurance.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorZimbabweMotorInsurance.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorZimbabweMotorInsurance.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorZimbabweMotorInsurance;
}(Base));
export { CalculatorZimbabweMotorInsurance };



//////////////////
// WEBPACK FOOTER
// ./components-zimbabwe/calculator-zimbabwe-motor-insurance/calculator-zimbabwe-motor-insurance.component.ts
// module id = 684
// module chunks = 0